import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import api from '../services/api';

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/token/', { username, password });
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      // first_name/last_name vêm no body (via validate) OU no payload JWT
      const payload = JSON.parse(atob(response.data.access.split('.')[1]));
      localStorage.setItem('first_name', response.data.first_name || payload.first_name || '');
      localStorage.setItem('last_name',  response.data.last_name  || payload.last_name  || '');
      localStorage.setItem('username',   response.data.username   || payload.username   || '');
      localStorage.setItem('is_staff',      String(response.data.is_staff ?? payload.is_staff ?? false));
      localStorage.setItem('is_superuser',  String(response.data.is_superuser ?? payload.is_superuser ?? false));
      if (response.data.trial_expira_em) localStorage.setItem('trial_expira_em', response.data.trial_expira_em);
      if (response.data.plano)           localStorage.setItem('plano', response.data.plano);
      navigate('/dashboard');
    } catch (err) {
      const erroEmpresa = err.response?.data?.non_field_errors?.[0];
      setError(erroEmpresa || 'Usuário ou senha inválidos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-glow login-glow-1" />
      <div className="login-glow login-glow-2" />

      <main className="login-main">
        {/* Card */}
        <div className="login-card">
          <div className="login-card-accent" />

          <div className="login-card-body">
            {/* Logo */}
            <div className="login-logo-wrap">
              <img src="/logo_hope.png" alt="Hope System" className="login-logo-img" />
            </div>

            {/* Título */}
            <div className="login-header">
              <h1 className="login-title">Acesso Restrito</h1>
              <p className="login-subtitle">Insira suas credenciais para gerenciar o estoque.</p>
            </div>

            {/* Erro */}
            {error && (
              <div className="login-error">
                <span className="material-symbols-outlined">error</span>
                {error}
              </div>
            )}

            {/* Formulário */}
            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-field">
                <label className="login-label" htmlFor="username">Usuário</label>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">person</span>
                  <input
                    id="username"
                    type="text"
                    className="login-input"
                    placeholder="nome.usuario"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="login-field">
                <div className="login-label-row">
                  <label className="login-label" htmlFor="password">Senha</label>
                  <a href="#!" className="login-forgot">Esqueceu a senha?</a>
                </div>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">lock</span>
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    className="login-input login-input-password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="login-toggle-pw"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label="Mostrar/ocultar senha"
                  >
                    <span className="material-symbols-outlined">
                      {showPassword ? 'visibility_off' : 'visibility'}
                    </span>
                  </button>
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? (
                  'Entrando...'
                ) : (
                  <>
                    Entrar no Sistema
                    <span className="material-symbols-outlined">arrow_forward</span>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Rodapé do card */}
          <div className="login-card-footer">
            <p>
              Não tem conta?{' '}
              <a href="/registrar" onClick={(e) => { e.preventDefault(); navigate('/registrar'); }}>
                Cadastre sua empresa
              </a>
            </p>
          </div>
        </div>

        {/* Slogan */}
        <footer className="login-footer">
          <p className="login-slogan">Tecnologia. Confiança. Resultados.</p>
          <p className="login-copy">© 2024 Hope System Corporate . Todos os direitos reservados.</p>
          <a
            href="https://www.hopesystem.com.br/privacidade"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'rgba(255,255,255,0.45)', fontSize: '12px', textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.25)', marginTop: '6px', display: 'inline-block' }}
          >
            Política de Privacidade
          </a>
        </footer>
      </main>
    </div>
  );
}

export default Login;
